import { analyticsIdentify, analyticsTrack } from '../analytics_util';
import { emailRegex, ready } from '../utils';

const ACCESS_SUBSCRIBER = '2';

const createLeadAjax = async (userParams, otherParams, endpoint, redirect, leadTrackingParams) => {
  const csrf_token = document.querySelector('meta[name="csrf-token"]'),
    headers = new Headers({
      Accept: 'application/json',
      'content-type': 'application/json',
      'X-CSRF-Token': csrf_token ? csrf_token.content : 'TEST_CSRF_TOKEN', // Provide a fallback for Selenium testing
    }),
    requestBody = {
      user: userParams,
      redirect_to_on_success: redirect,
      ...otherParams,
    },
    payload = {
      method: 'POST',
      headers: headers,
      credentials: 'same-origin',
      body: JSON.stringify(requestBody),
    },
    request = new Request(endpoint, payload);
  const response = await fetch(request);
  if (response.ok) {
    const responseBody = await response.json();
    if (responseBody.new_lead) {
      ahoy.track('lead-conversion');
      analyticsIdentify(responseBody.user_id, {
        email: userParams.email,
        call_location: 'locked_homepage',
      });
      analyticsTrack('lead-conversion');

      window['optimizely'] = window['optimizely'] || [];
      window['optimizely'].push({
        type: 'event',
        eventName: 'lead',
        tags: {
          revenue: 0, // Optional in cents as integer (500 == $5.00)
          value: 0.0, // Optional as float
        },
      });

      // track in google analytics
      window.dataLayer = window.dataLayer || []; // make sure dataLayer exists

      const dataLayerVariables = {
        event: 'lead-conversion',
        eventModel: {
          leadType: userParams.lead_type,
          ...leadTrackingParams,
        },
      };
      window.dataLayer.push(dataLayerVariables);
    }
    return responseBody.location;
  } else if (response.status == 422) {
    // 422s are errors we expect to happen; see user_controller#render_result
    const responseBody = await response.json();
    throw responseBody.message;
  }
  throw 'Something went wrong. Please try again.';
};

const createLeadLockedHomepage = async (e) => {
  if (e.type == 'keydown' && e.key != 'Enter') {
    // Only respond to 'Enter' key events
    return;
  }
  const elt = e.target;
  const formGroup = elt.closest('.get-started-form-group');
  const email = formGroup.querySelector('input').value;
  const optInCheckbox = formGroup
    .closest(
      '.locked, .read-this-article-immersive, .read-this-article, #immersive-article-modal, .ti-static, .newsletter-landing, #newsletters, .feed-newsletter, #weekend-landing, #company-landing-page, #feed-newsletter-container, #feed-newsletter-container-header, #feed-newsletter-container-middle, #feed-newsletter-container-footer, .modal-container, #pro-paywall, #lead-sticky-banner, .org-signup'
    )
    .querySelector('.opt-in'); // This will only be present for EU users
  const declinedOptIn = optInCheckbox ? optInCheckbox.checked == false : false,
    articleId = currentPage.articleId,
    briefingGuid = currentPage.briefingGuid, // Pass an article id or briefing guid, if on an article/briefing page
    errorField = formGroup.querySelector('.get-started-error'),
    successField = formGroup.querySelector('.get-started-success'),
    btn = formGroup.querySelector('.get-started-button'),
    btnText = btn.innerHTML,
    endpoint = btn.dataset.submitUri,
    redirect = btn.dataset.redirectUri,
    leadType = btn.dataset.leadType,
    formLocation = btn.dataset.formLocation,
    page = btn.dataset.page,
    leadDetails = btn.dataset.leadDetails ? JSON.parse(btn.dataset.leadDetails) : {},
    forceEmailAuth = btn.dataset.forceEmailAuth,
    shareGuid = btn.dataset.shareGuid,
    showSuccessMessage = btn.dataset.showSuccessMessage,
    googleSignIn = document.querySelector('.google-signin-container');
  btn.innerHTML = `<div class="spinner" ><i class="fa fa-refresh fa-spin"></i></div>`;
  const spinner = document.querySelector('.get-started-button .spinner');
  // Filter out pro newsletters with access_level = 4
  const selectedNewsletterIds = [
    ...document.querySelectorAll('.newsletter-subscribed, #weekend-landing'),
  ]
    .filter((nl) => nl.dataset.newsletterAccessLevel < ACCESS_SUBSCRIBER)
    .map((elt) => elt.dataset.newsletterId);

  spinner.style.display = 'block';
  try {
    removeLeadCaptures();
    errorField.classList.remove('has-error');
    if (googleSignIn) {
      googleSignIn.style.marginTop = '0';
    }
    // Don't bother checking with the server if the email is obviously invalid
    if (!email.match(emailRegex)) {
      throw leadType === 'china_newsletter_newsletter_lead'
        ? '请输入正确形式的邮箱地址。'
        : 'Please enter a valid email.'; // if on a Chinese language page, throw an error in Chinese
    }
    const redirectUri = await createLeadAjax(
      {
        email: email,
        declined_opt_in: declinedOptIn,
        opt_in_required: !!optInCheckbox,
        lead_type: leadType,
        form_location: formLocation,
        page: page,
      },
      {
        article_id: articleId,
        briefing_guid: briefingGuid,
        newsletter_ids: selectedNewsletterIds,
        force_email_auth: forceEmailAuth,
        share_guid: shareGuid,
      },
      endpoint,
      redirect,
      leadDetails
    );
    if (showSuccessMessage) {
      successField.innerHTML = 'Subscribed! You will be redirected shortly …';
      successField.classList.remove('hide');
      setTimeout(() => {
        window.location.href = redirectUri;
      }, 4000);
    } else {
      window.location.href = redirectUri;
    }
  } catch (e) {
    errorField.innerHTML = e;
    errorField.classList.add('has-error');
    if (googleSignIn) {
      googleSignIn.style.marginTop = '50px';
    }
    btn.innerHTML = btnText;
    addLeadCaptures();
  }
};

const addLeadCaptures = () => {
  [...document.querySelectorAll('.get-started-form-group')].forEach((grp) => {
    const input = grp.querySelector('.get-started-input'),
      btn = grp.querySelector('.get-started-button');
    input.classList.remove('disabled');
    input.addEventListener('keydown', createLeadLockedHomepage);
    btn.addEventListener('click', createLeadLockedHomepage);
  });
};

const removeLeadCaptures = () => {
  [...document.querySelectorAll('.get-started-form-group')].forEach((grp) => {
    const input = grp.querySelector('.get-started-input'),
      btn = grp.querySelector('.get-started-button');
    btn.removeEventListener('click', createLeadLockedHomepage);
    input.removeEventListener('keydown', createLeadLockedHomepage);
    input.classList.add('disabled');
  });
};

ready(addLeadCaptures);

export { addLeadCaptures, createLeadLockedHomepage };
